import { isEmpty, isPlainObject } from 'lodash-es';

export const isRecordType = (data: unknown): data is Record<string, unknown> =>
  isPlainObject(data) && !isEmpty(data);

declare const tag: unique symbol;
type InvariantSignature<Type> = {
  readonly [tag]: (_: Type) => Type;
};
type InvariantOf<Type> = Type & InvariantSignature<Type>;

export const createInvariantType = <T>(value: unknown) => value as InvariantOf<T>;
